import { trackRouteChange } from 'pb-tracking';

/** SPA navigations reach the shared zone Worker through its same-origin endpoint. */
export default defineNuxtPlugin(() => {
  if (import.meta.dev || !useRuntimeConfig().public.tracking.enabled) return;

  useRouter().afterEach(trackRouteChange);
});
